import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Host, Menu, AppService, SearchResult} from "../../../../../common";

import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";
import {Subject} from "rxjs";
import {Cart, CartService} from "../../../../../common";

@Component({
  selector: 'search',
  standalone: false,
  templateUrl: './search.html'
})

export class SearchPage implements OnInit {

  host: Host = null;
  menu: Menu = null;
  cart: Cart = null;
  searchTerm$ = new Subject<string>();
  result: SearchResult = null;
  searchExamples: string = null;

  constructor(
    private appService: AppService
  ) { }

  ngOnInit(): void {

    this.searchTerm$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      map(term=> this.menu.search(term))
    ).subscribe(result => {
      this.result = result
    });

    this.appService
      .load()
      .subscribe( ({host, menu, cart}) => {
        this.host = host;
        this.menu = menu;
        this.cart = cart;

        this.searchExamples = this.getRandom(this.menu.groups).name + ', ' + this.getRandom(this.menu.items).name + ', ...';

      });
  }

  getRandom(sel: Record<number, any>): any {
    const keys = Object.keys(sel).filter(k => sel[k].isVisible()),
          rnd = Math.floor(Math.random()*keys.length),
          key = keys[rnd];
    return sel[key];
  }

}
